var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "l2u-login-redirect" }, [
    _c(
      "svg",
      {
        staticClass: "route-paths-svg",
        attrs: { viewBox: "0 0 500 700", preserveAspectRatio: "none" },
      },
      [
        _c(
          "defs",
          [
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "routeGrad1",
                  x1: "0%",
                  y1: "0%",
                  x2: "100%",
                  y2: "100%",
                },
              },
              [
                _c("stop", {
                  attrs: {
                    offset: "0%",
                    "stop-color": "rgba(43,147,255,0.12)",
                  },
                }),
                _c("stop", {
                  attrs: {
                    offset: "100%",
                    "stop-color": "rgba(43,147,255,0.03)",
                  },
                }),
              ],
              1
            ),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "routeGrad2",
                  x1: "100%",
                  y1: "0%",
                  x2: "0%",
                  y2: "100%",
                },
              },
              [
                _c("stop", {
                  attrs: { offset: "0%", "stop-color": "rgba(78,210,255,0.1)" },
                }),
                _c("stop", {
                  attrs: {
                    offset: "100%",
                    "stop-color": "rgba(78,210,255,0.02)",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("path", {
          staticClass: "route-dash",
          attrs: {
            d: "M 60 0 Q 60 180, 200 250 T 400 400 T 300 700",
            fill: "none",
            stroke: "url(#routeGrad1)",
            "stroke-width": "1.5",
            "stroke-dasharray": "8 6",
          },
        }),
        _c("path", {
          staticClass: "route-dash route-dash--slow",
          attrs: {
            d: "M 350 0 Q 350 120, 250 200 T 100 380 T 200 700",
            fill: "none",
            stroke: "url(#routeGrad2)",
            "stroke-width": "1.5",
            "stroke-dasharray": "8 6",
          },
        }),
        _c("path", {
          staticClass: "route-dash route-dash--slower",
          attrs: {
            d: "M 450 100 Q 400 250, 280 300 T 50 500",
            fill: "none",
            stroke: "rgba(43,147,255,0.08)",
            "stroke-width": "1",
            "stroke-dasharray": "4 8",
          },
        }),
        _c("circle", {
          staticClass: "waypoint",
          attrs: { cx: "200", cy: "250", r: "3", fill: "rgba(43,147,255,0.4)" },
        }),
        _c("circle", {
          staticClass: "waypoint waypoint--d1",
          attrs: {
            cx: "350",
            cy: "120",
            r: "3",
            fill: "rgba(78,210,255,0.35)",
          },
        }),
        _c("circle", {
          staticClass: "waypoint waypoint--d2",
          attrs: { cx: "100", cy: "380", r: "3", fill: "rgba(43,147,255,0.3)" },
        }),
        _c("circle", {
          staticClass: "waypoint waypoint--d3",
          attrs: { cx: "400", cy: "400", r: "3", fill: "rgba(78,210,255,0.3)" },
        }),
      ]
    ),
    _c("div", { staticClass: "redirect-card" }, [
      _c("img", {
        staticClass: "card-logo",
        attrs: { src: "/img/icons/locate2u-logo.png", alt: "Locate2u" },
      }),
      _c("div", { class: ["spinner-ring", { done: _vm.allDone }] }, [
        _vm.allDone
          ? _c(
              "svg",
              {
                attrs: {
                  width: "36",
                  height: "36",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "#059669",
                  "stroke-width": "2",
                },
              },
              [
                _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
                _c("polyline", { attrs: { points: "8 12 11 15 16 9" } }),
              ]
            )
          : _c(
              "svg",
              {
                staticClass: "spinner-arc",
                attrs: { width: "72", height: "72", viewBox: "0 0 72 72" },
              },
              [
                _c("circle", {
                  attrs: {
                    cx: "36",
                    cy: "36",
                    r: "32",
                    fill: "none",
                    stroke: "#EAF2FB",
                    "stroke-width": "3",
                  },
                }),
                _c("circle", {
                  staticClass: "arc",
                  attrs: {
                    cx: "36",
                    cy: "36",
                    r: "32",
                    fill: "none",
                    stroke: "#2B93FF",
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-dasharray": "60 141",
                  },
                }),
              ]
            ),
      ]),
      _c("h2", { staticClass: "heading" }, [_vm._v(_vm._s(_vm.heading))]),
      _c("p", { staticClass: "status-text" }, [
        _vm._v(_vm._s(_vm.statusMessage)),
      ]),
      _c("div", { staticClass: "progress-track" }, [
        _c("div", {
          class: ["progress-bar", { done: _vm.allDone }],
          style: { width: _vm.progressPercent + "%" },
        }),
      ]),
      _c(
        "div",
        { staticClass: "steps" },
        _vm._l(_vm.steps, function (step, i) {
          return _c(
            "div",
            {
              key: i,
              class: [
                "step",
                { active: _vm.currentStep === i, done: _vm.currentStep > i },
              ],
            },
            [
              _c("div", { staticClass: "step-indicator" }, [
                _vm.currentStep > i
                  ? _c(
                      "svg",
                      {
                        attrs: {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "#059669",
                          "stroke-width": "3",
                        },
                      },
                      [_c("polyline", { attrs: { points: "20 6 9 17 4 12" } })]
                    )
                  : step.icon === "lock"
                  ? _c(
                      "svg",
                      {
                        attrs: {
                          width: "18",
                          height: "18",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: _vm.currentStep === i ? "#2B93FF" : "#C5CFDD",
                          "stroke-width": "2",
                        },
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "3",
                            y: "11",
                            width: "18",
                            height: "11",
                            rx: "2",
                          },
                        }),
                        _c("path", { attrs: { d: "M7 11V7a5 5 0 0110 0v4" } }),
                      ]
                    )
                  : step.icon === "grid"
                  ? _c(
                      "svg",
                      {
                        attrs: {
                          width: "18",
                          height: "18",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: _vm.currentStep === i ? "#2B93FF" : "#C5CFDD",
                          "stroke-width": "2",
                        },
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "3",
                            y: "3",
                            width: "7",
                            height: "7",
                            rx: "1",
                          },
                        }),
                        _c("rect", {
                          attrs: {
                            x: "14",
                            y: "3",
                            width: "7",
                            height: "7",
                            rx: "1",
                          },
                        }),
                        _c("rect", {
                          attrs: {
                            x: "3",
                            y: "14",
                            width: "7",
                            height: "7",
                            rx: "1",
                          },
                        }),
                        _c("rect", {
                          attrs: {
                            x: "14",
                            y: "14",
                            width: "7",
                            height: "7",
                            rx: "1",
                          },
                        }),
                      ]
                    )
                  : step.icon === "route"
                  ? _c(
                      "svg",
                      {
                        attrs: {
                          width: "18",
                          height: "18",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: _vm.currentStep === i ? "#2B93FF" : "#C5CFDD",
                          "stroke-width": "2",
                        },
                      },
                      [
                        _c("circle", { attrs: { cx: "6", cy: "6", r: "3" } }),
                        _c("circle", { attrs: { cx: "18", cy: "18", r: "3" } }),
                        _c("path", {
                          attrs: { d: "M6 9v2a4 4 0 004 4h4a4 4 0 014 4v-1" },
                        }),
                      ]
                    )
                  : _vm._e(),
              ]),
              _c("span", { staticClass: "step-label" }, [
                _vm._v(_vm._s(step.label)),
              ]),
              _vm.currentStep === i && _vm.currentStep < _vm.steps.length
                ? _c("div", { staticClass: "active-dot" })
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ]),
    _c("p", { staticClass: "bottom-trust" }, [
      _vm._v("Locate2u — Route optimisation and delivery management"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }